import ExportOutlined from '@ant-design/icons/ExportOutlined';
import MoreOutlined from '@ant-design/icons/MoreOutlined';
import App from 'antd/es/app';
import Button from 'antd/es/button';
import Descriptions from 'antd/es/descriptions';
import Dropdown from 'antd/es/dropdown';

import ContentContainer from '@components/ContentContainer';
import SectionContainer from '@components/SectionContainer';
import { updateSource, useSourceQuery } from '@queries/sources';
import { useBreadcrumbs, useSourceId, useTeamId } from '@utils/router';

const LibrarySourceDetailsPage = () => {
  const { message } = App.useApp();
  const sourceId = useSourceId();
  const teamId = useTeamId();
  const breadcrumbs = useBreadcrumbs();

  const sourceQuery = useSourceQuery(sourceId);
  const source = sourceQuery.data;

  if (sourceQuery.isLoading || !sourceId || !teamId) {
    return <ContentContainer.Loading />;
  }

  if (!source) {
    return <ContentContainer.NotFound />;
  }

  return (
    <ContentContainer>
      <ContentContainer.Header
        title="Source Details"
        breadcrumbs={breadcrumbs}
        cta={
          <div>
            <Dropdown
              menu={{
                items: [
                  {
                    label: 'Preview (coming soon)',
                    key: 'preview',
                    disabled: true,
                  },
                  {
                    label: 'Re-process',
                    key: 're-process',
                    onClick: async () => {
                      const loadingMessage = message.loading(
                        'Re-processing source...',
                      );
                      try {
                        await updateSource(sourceId, { shouldProcess: true });
                      } finally {
                        loadingMessage();
                      }
                    },
                  },
                ],
              }}
            >
              <Button icon={<MoreOutlined />}>Actions</Button>
            </Dropdown>
          </div>
        }
      />
      <SectionContainer title="Properties">
        <Descriptions column={1} layout="vertical">
          <Descriptions.Item label="Title">{source.title}</Descriptions.Item>
          <Descriptions.Item label="Description">
            {source.description ?? '-'}
          </Descriptions.Item>
          <Descriptions.Item label="Source URL">
            {source.url ? (
              <a href={source.url} target="_blank">
                {new URL(source.url).hostname}
                <ExportOutlined style={{ marginLeft: 8 }} />
              </a>
            ) : (
              'N/A'
            )}
          </Descriptions.Item>
        </Descriptions>
      </SectionContainer>
    </ContentContainer>
  );
};

export default LibrarySourceDetailsPage;
